import { Group, Path } from "@progress/kendo-drawing";
import { RiskVsReturnMarkerRenderer } from "./RiskVsReturnMarkerRenderer";
import {
  RiskVsreturnScatterChart,
  ScatterItem,
} from "./RiskVsReturnScatterChart";
import {
  IGlobalPeriodContext,
  useGlobalCurrency,
  useScatterDrawingLogic,
} from "@iliotech/data-wire";
import { ConnectedInformationButton } from "src/main";
import RiskVsReturnScatterLegend from "./RiskVsReturnScatterLegend";

export const RiskVsReturnScatter = ({
  items,
  getItemValue,
  height,
  width,
  isForReport,
  periodString,
  isHalfWidth,
}: {
  items: ScatterItem[];
  getItemValue: (v?: string) => number;
  height?: number;
  width?: number;
  isForReport?: boolean;
  periodOverride?: IGlobalPeriodContext;
  periodString?: string;
  isHalfWidth?: boolean;
}) => {
  const percentageFormatter = (value: number) =>
    value?.toLocaleString(undefined, { minimumFractionDigits: 0 }) + "%";
  const portfolioItem = items.find((item) => item.category === "Portfolio");
  const { currencyFormatter } = useGlobalCurrency();
  const { drawLines } = useScatterDrawingLogic(portfolioItem);
  const Wrapper = isForReport ? "div" : "article";
  const legendItems = items.map((item) => ({
    label: item.category,
    color: item.color,
  }));
  return (
    <Wrapper>
      <ConnectedInformationButton code={"scatter"}>
        <h4 className={"element-title"}>
          Annualised Return vs 1 Yr Daily Volatility
        </h4>
      </ConnectedInformationButton>
      <p className={"period-string"}>{periodString}</p>
      <RiskVsreturnScatterChart
        getItemValue={getItemValue}
        currencyFormatter={currencyFormatter}
        onRender={drawLines}
        items={items}
        markerRenderer={RiskVsReturnMarkerRenderer}
        yAxisTitle="Return"
        xAxisTitle="Risk"
        xAxisFormatter={percentageFormatter}
        yAxisFormatter={percentageFormatter}
        height={height}
        width={width}
      />
      <RiskVsReturnScatterLegend
        isHalfWidth={isHalfWidth}
        items={legendItems}
      />
    </Wrapper>
  );
};
